import React, { useState } from 'react'
import { Box, Button, TextField } from '@mui/material'
import { useSnackbar } from 'notistack'
import { useLinkDealMutation } from '../../../redux/growthosBrandsApiSlice'

/** Blank-input variant of MappingEditor, for brands with zero mappings — matches the real
 * app's NewMappingEditor exactly: no status chip at all, just an input + a text "Map" button
 * (unlike the icon-only Save button used once a mapping already exists). Reuses the existing
 * linkDeal endpoint (sourceDealId defaults to the same value as hubspotDealId, source
 * 'MANUAL'), since that's exactly the "add first mapping" case this endpoint already covers. */
export default function NewMappingEditor({ brandId }) {
  const { enqueueSnackbar } = useSnackbar()
  const [linkDeal, state] = useLinkDealMutation()
  const [value, setValue] = useState('')

  const save = async () => {
    const dealId = value.trim()
    if (!dealId) return
    try {
      await linkDeal({ id: brandId, hubspotDealId: dealId, source: 'MANUAL' }).unwrap()
      enqueueSnackbar('Mapping added.', { variant: 'success' })
      setValue('')
    } catch (e) {
      enqueueSnackbar(e?.data?.message || e?.message || 'Failed to add mapping.', { variant: 'error' })
    }
  }

  return (
    <Box sx={{ display: 'flex', gap: 0.75 }}>
      <TextField
        size="small"
        aria-label="Add HubSpot Deal ID"
        placeholder="Exact HubSpot Deal ID"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        sx={{ flex: 1, minWidth: 0, '& input': { fontSize: 11, fontFamily: 'monospace', py: 0.4 } }}
      />
      <Button
        size="small" variant="outlined" disabled={!value.trim() || state.isLoading} onClick={save}
        sx={{ textTransform: 'none', fontSize: 11, px: 1.5, borderRadius: '10px' }}
      >
        Map
      </Button>
    </Box>
  )
}
